import { AfterViewInit, Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { FormsService } from '../../providers/forms.service';
import { ScrollService } from '../../providers/scroll.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseService } from '../../providers/firebase.service';
import { LocationInfo } from "../../models/locationInfo";
import { Client } from "../../models/client";
import 'rxjs/add/operator/first';
import * as _ from 'lodash';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-seo',
  templateUrl: './seo.component.html',
  styleUrls: ['./seo.component.css']
})
export class SeoComponent implements OnInit, AfterViewInit, OnDestroy {
  showLoading = true;
  showSpinner = false;
  clientKey: string;
  clientData: Client;
  locationsData: LocationInfo[];
  dropdownOptions = [{ label: 'Main', value: 'main' }];
  selection = 'main';
  selectedNavigation;
  navigationKeys: string[];
  navigationLoading = true;
  removeListener: Function;

  constructor(
    public forms: FormsService,
    public route: ActivatedRoute,
    public afService: FirebaseService,
    private scroll: ScrollService,
    public router: Router,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
  ) { }

  async ngOnInit() {
    this.clientKey = this.route.snapshot.params.key;
    this.clientData = await this._getClient();
    this.navigationKeys = Object.keys(this.clientData.navigation);
    this.selectedNavigation = this.clientData.navigation;
    console.log(this.selectedNavigation);
    this.locationsData = await this._getLocations();
    for (let l of this.locationsData) {
      this.dropdownOptions.push({ label: l.name, value: l.$key });
    }
    this.navigationLoading = false;
    this.showLoading = false;
    this.removeListener = this.renderer.listen('window', 'keydown', (event: KeyboardEvent) => {
      if (event.ctrlKey && event.keyCode === 83) {
        this.afService.updateSettingsOnServer(this.clientData);
      }
    });
  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();
  }

  ngOnDestroy() {
    this.removeListener();
  }

  async save() {
    try {
      if (this.selection === 'main') {
        await this.afService.saveMainNavItems(this.route.snapshot.params.key, this.selectedNavigation);
        for (let key in this.selectedNavigation) {
          if (this.selectedNavigation[key].isDropDown && this.selectedNavigation[key].children) {
            for (let child of this.selectedNavigation[key].children) {
              if (child.isCustomPage) {
                await this.updateCustomPage(child);
              }
            }
          }
          else if (this.selectedNavigation[key].isCustomPage) {
            await this.updateCustomPage(this.selectedNavigation[key]);
          }
        }
        this.afService.openSnackBar('Saved: Main Nav Items');
      }
      else {
        await this.afService.saveLocationNavItems(this.route.snapshot.params.key, this.selection, this.selectedNavigation);
        this.afService.openSnackBar(`Saved: ${ _.find(this.locationsData, ['$key', this.selection]).name } Nav Items`);
      }
    }
    catch (e) {
      console.error(e);
      this.afService.openSnackBar(e);
    }
  }

  displayCount(str: string, type: string) {
    if (!(!!str && !!type)) return this.sanitizer.bypassSecurityTrustHtml('<span style="font-weight:normal;color:red;">0</span>');

    let l = str.length, yellowLow, yellowHigh, greenLow, greenHigh, color = 'rgba(0,0,0,0.33)';
    if (type === 'title') {
      yellowLow = 20; yellowHigh = 80; greenLow = 40; greenHigh = 60;
    }
    else {
      yellowLow = 39; yellowHigh = 161; greenLow = 49; greenHigh = 151;
    }

    if (l > greenLow && l < greenHigh) {
      color = 'green';
    }
    if (l < greenLow || l > greenHigh) {
      color = 'yellow';
    }
    if (l < yellowLow || l > yellowHigh) {
      color = 'red';
    }

    return this.sanitizer.bypassSecurityTrustHtml(`<span style="font-weight:normal;color:${ color };">${ l }</span>`);
  }

  getSelectedNavigation() {
    this.navigationLoading = true;
    if (this.selection === 'main') {
      this.selectedNavigation = this.clientData.navigation;
    }
    else {
      const location = _.find(this.locationsData, ['$key', this.selection]);
      if (!location.navigation) {
        location.navigation = this._buildLocationNav(location.name);
      }
      this.selectedNavigation = location.navigation;
    }
    this.navigationLoading = false;
  }

  private async updateCustomPage(customPageData) {
    let tmp = { key: customPageData.key };
    if (customPageData.name) {
      tmp['name'] = customPageData.name;
    }
    if (customPageData.metaTitle) {
      tmp['metaTitle'] = customPageData.metaTitle;
    }
    if (customPageData.metaImage) {
      tmp['metaImage'] = customPageData.metaImage;
    }
    if (customPageData.metaImageAlt) {
      tmp['metaImageAlt'] = customPageData.metaImageAlt;
    }
    if (customPageData.metaDescription) {
      tmp['metaDescription'] = customPageData.metaDescription;
    }
    await this.afService.updateCustomPage(tmp, this.route.snapshot.params.key);
  }

  private _buildLocationNav(locationName: string) {
    const rtn = {};
    for (let i in this.clientData.navigation) {
      if (this.clientData.navigation[i].isDropDown) {
        rtn[i] = this.clientData.navigation[i];
        if (rtn[i].children) {
          for (let j = 0; j < this.clientData.navigation[i].children.length; j++) {
            rtn[i].children[j] = _.cloneDeep(this.clientData.navigation[i].children[j]);
            rtn[i].children[j].metaTitle = `${ rtn[i].children[j].name } | ${ locationName } | ${ this.clientData.name }`;
            rtn[i].children[j].metaImageAlt = rtn[i].children[j].metaTitle;
            rtn[i].children[j].metaDescription = `${ this.clientData.navigation[i].children[j].metaDescription || rtn[i].children[j].name } ${ locationName }`;
            rtn[i].children[j].metaImage = this.clientData.navigation[i].children[j].metaImage || '';
          }
        }
      }
      else {
        rtn[i] = _.cloneDeep(this.clientData.navigation[i]);
        rtn[i].metaTitle = `${ rtn[i].name } | ${ locationName } | ${ this.clientData.name }`;
        rtn[i].metaImageAlt = rtn[i].metaTitle;
        rtn[i].metaDescription = `${ this.clientData.navigation[i].metaDescription || rtn[i].name } ${ locationName }`;
        rtn[i].metaImage = this.clientData.navigation[i].metaImage || '';
      }
    }

    return rtn;
  }

  private _getClient(): Promise<Client> {
    return new Promise((resolve, reject) => {
      this.afService.getClientInfo(this.clientKey).first()
        .subscribe((data: Client) => resolve(data), error => reject(error));
    });
  }

  private _getLocations(): Promise<(LocationInfo)[]> {
    return new Promise((resolve, reject) => {
      this.afService.getLocationsByKey(this.clientKey).first()
        .subscribe((data: LocationInfo[]) => resolve(data), error => reject(error));
    });
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/seo/seo.component.ts